import React from 'react';
import {
  MessageBar,
  MessageBarBody,
  FluentProvider,
  webLightTheme,
} from '@fluentui/react-components';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { ApolloError } from '@apollo/client';

interface IErrorMessageProps {
  loading: boolean;
  error: ApolloError | undefined;
  actionName?: string;
}

const LoadingErrorMessage = ({
  loading,
  error,
  actionName,
}: IErrorMessageProps): JSX.Element | null => {
  if (loading || !error) {
    return null;
  }
  const formatErrorMessage = (): string => {
    if (!actionName) {
      return 'An error occurred loading data from the server';
    }

    return `An error occurred ${actionName}.`;
  };

  if (loading || !error) {
    return null;
  }
  return (
    <FluentProvider theme={webLightTheme}>
      <MessageBar intent="error" layout="multiline">
        <MessageBarBody>
          <Stack tokens={{ childrenGap: 10 }}>
            <span>{formatErrorMessage()}</span>
            <span>{error.message}</span>
          </Stack>
        </MessageBarBody>
      </MessageBar>
    </FluentProvider>
  );
};

export default LoadingErrorMessage;
